var map = {
	"./demos/basic/index.ts": 70047,
	"./demos/checkbox/index.ts": 80078,
	"./demos/filter/index.ts": 87374,
	"./demos/load/index.ts": 91031,
	"./demos/multiple/index.ts": 48529
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 31081;